import { EVENT_LOGIN_SUCCESS } from "@constants/auth-events";

/**
 * Emits a login success event that can be listened to by any component or hook.
 * This event is fired when a user successfully logs in (not on token refresh).
 */
export function emitLoginSuccess() {
  window.dispatchEvent(new Event(EVENT_LOGIN_SUCCESS));
}
